<script setup>
import { ref, computed, watch } from 'vue';
import UrlVariableList from '../conversation/UrlVariableList.vue';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:modelValue', 'input', 'blur']);

const showVariables = ref(false);
const variableSearchTerm = ref('');

const shouldShowVariables = computed(() => showVariables.value);

watch(
  () => props.modelValue,
  val => {
    const stringValue = String(val || '');
    if (/{{([^{}]*)$/.test(stringValue) && !stringValue.endsWith('}}')) {
      showVariables.value = true;
      const match = stringValue.match(/{{([^{}]*)$/);
      variableSearchTerm.value = match ? match[1] : '';
    } else {
      showVariables.value = false;
    }
  }
);

const insertVariable = variable => {
  const currentValue = String(props.modelValue || '');
  const newValue = currentValue.replace(
    /(.*)(\{{)([^{}]*)$/,
    (match, p1) => p1 + '{{' + variable + '}}'
  );
  showVariables.value = false;
  emit('update:modelValue', newValue);
  emit('input', newValue);
};

const handleInput = value => {
  emit('update:modelValue', value);
  emit('input', value);
};

const handleBlur = value => {
  emit('blur', value);
};
</script>

<template>
  <div class="relative">
    <UrlVariableList
      v-if="shouldShowVariables"
      :search-key="variableSearchTerm"
      @select-variable="insertVariable"
    />
    <woot-input
      v-bind="$attrs"
      :model-value="modelValue"
      @update:model-value="handleInput"
      @input="handleInput"
      @blur="handleBlur"
    />
  </div>
</template>
